import BaseBubbleController from "./BaseBubbleController.js";

export default class AssistantGeneratingBubbleController extends BaseBubbleController {
  constructor() {
    super("assistant-generating", "assistant");
  }

  renderBubbleHtml() {
    return `
      <div class="bubble-controller-generating" data-bubble-context-menu-target="true">
        <span class="bubble-controller-generating-dot"></span>
        <span class="bubble-controller-generating-dot"></span>
        <span class="bubble-controller-generating-dot"></span>
      </div>
    `.trim();
  }

  getContent() {
    return "";
  }
}
